<div id="widget-container">
  <span class="energyToolWidgetTitle">{{ "energy_tool.weather_report.weather_report" | translate }}</span>
  @if (timeOut()) {
    <app-timeout></app-timeout>
  } @else if (loading()) {
    <p-progressSpinner ariaLabel="loading" class="customProgressSpinner" />
  } @else if (!dataIsCurrent()) {
    <div class="w-full h-full flex justify-content-center align-items-center">
      <p>
        {{ "energy_tool.weather_report.old_data" | translate }}
      </p>
    </div>
  } @else {
    @if (weatherData) {
      <div id="content-container">
        <div id="today-label" class="label">
          {{ "energy_tool.weather_report.today_capital" | translate }}
        </div>
        <div class="weather-kpi-container" id="morning-container">
          <img
            [src]="weatherData.today.morning.icon"
            [alt]="weatherData.today.morning.alt"
            [ngStyle]="getImageHeight()"
          />
          <span>
            {{ weatherData.today.morning.temperature | number: "1.0-0" : "de" }}
            ºC
          </span>
          <span class="time-of-day">{{ "energy_tool.weather_report.morning" | translate }}</span>
        </div>

        <div class="weather-kpi-container" id="noon-container">
          <img [src]="weatherData.today.noon.icon" [alt]="weatherData.today.noon.alt" [ngStyle]="getImageHeight()" />
          <span> {{ weatherData.today.noon.temperature | number: "1.0-0" : "de" }} ºC </span>
          <span class="time-of-day">{{ "energy_tool.weather_report.noon" | translate }}</span>
        </div>

        <div class="weather-kpi-container" id="evening-container">
          <img
            [src]="weatherData.today.evening.icon"
            [alt]="weatherData.today.evening.alt"
            [ngStyle]="getImageHeight()"
          />
          <span>
            {{ weatherData.today.evening.temperature | number: "1.0-0" : "de" }}
            ºC
          </span>
          <span class="time-of-day">{{ "energy_tool.weather_report.evening" | translate }}</span>
        </div>

        <div id="vertical-line"></div>

        <div id="tomorrow-label" class="label">
          {{ "energy_tool.weather_report.tomorrow_capital" | translate }}
        </div>

        <div class="weather-kpi-container" id="tomorrow-container">
          <img [src]="weatherData.tomorrow.icon" [alt]="weatherData.tomorrow.alt" [ngStyle]="getImageHeight()" />
          <span> min {{ weatherData.tomorrow.temperatureMin | number: "1.0-0" : "de" }} ºC </span>
          <span> max {{ weatherData.tomorrow.temperatureMax | number: "1.0-0" : "de" }} ºC </span>
        </div>

        <div id="day-after-label" class="label">
          {{ "energy_tool.weather_report.day_after_tomorrow_capital" | translate }}
        </div>

        <div class="weather-kpi-container" id="day-after-container">
          <img [src]="weatherData.dayAfter.icon" [alt]="weatherData.dayAfter.alt" [ngStyle]="getImageHeight()" />

          <span> min {{ weatherData.dayAfter.temperatureMin | number: "1.0-0" : "de" }} ºC </span>
          <span> max {{ weatherData.dayAfter.temperatureMax | number: "1.0-0" : "de" }} ºC </span>
        </div>
        <hr id="horizontal-line" />
        <div class="last-row flex gap-2 justify-content-between align-items-center">
          <div class="flex gap-1">
            <span> {{ "energy_tool.weather_report.expected_energy_loss" | translate }}</span>
            <app-svg-icon
              iconName="info-circle"
              iconSize="sm"
              tooltipPosition="bottom"
              [pTooltip]="translate.instant('energy_tool.weather_report.notice')"
              iconColor="secondary"
              class="flex"
            />
          </div>
          @if (forecastEnergyLossData()) {
            <select (change)="onExpectedChange($event)" class="last-row custom_select">
              @for (day of expectedEnergyLossOptions; track day) {
                <option [value]="day">
                  {{ "energy_tool.weather_report." + day + "_capital" | translate }}
                </option>
              }
            </select>
          } @else {
            <div>
              {{ "energy_tool.weather_report.not_enough_data" | translate }}
            </div>
          }
          @if (displayedForecastEnergyLoss()) {
            <div class="flex align-items-center gap-1">
              <div id="kpi-value">
                <span>{{ displayedForecastEnergyLoss() | number: "1.0-0" : "de" }}</span>
                <span>kWh</span>
              </div>
              @if (sourceType()) {
                @switch (sourceType()) {
                  @case (assetTypes.GATE_SYSTEM) {
                    <div id="kpi-label">
                      {{ "energy_tool.weather_report.at_this_gate" | translate }}
                    </div>
                  }
                  @case (assetTypes.BUILDING) {
                    <div id="kpi-label">
                      {{ "energy_tool.weather_report.at_this_building" | translate }}
                    </div>
                  }
                  @case (assetTypes.LOCATION) {
                    <div id="kpi-label">
                      {{ "energy_tool.weather_report.at_this_location" | translate }}
                    </div>
                  }
                }
              }
            </div>
          }
        </div>
      </div>
    } @else {
      <span class="noData">{{ "common.no_data" | translate }}</span>
    }
  }
</div>
